module.exports = __webpack_public_path__ + "media/7.0b2156b6.mp3";